import { computed, observable } from 'mobx';
import AssociatedAccountStore from '@src/models/account/associated-account';
import JsonService from '@src/services/json';
import { autobind } from 'core-decorators';
import intl from 'react-intl-universal';
// import { message } from 'antd';
import desensitizationEmail from '@src/utils/desensitizationEmail';
export const LOGIN_TYPE = {
  mail: 'mail',
  facebook: 'facebook',
  google: 'google',
  twitter: 'twitter',
  googleplay: 'googleplay',
  gamecenter: 'gamecenter',
  appleid: 'appleid',
  guest: 'guest'
};

export const ACCOUNT_TYPE = {
  normal: 0,
  delete: 1,
  deleted: 2
};
class AccountStore {
  /**
   * 登录返回的uid
   * @type {string}
   */
  @observable uid = '';

  $service = JsonService.getZTDefaultInstance({});

  /**
   * 登录类型
   * @type {string}
   */
  @observable type = LOGIN_TYPE['mail'];

  /**
   * 账号登录类型
   * @type {string} [common | login | register]
   */
  loginType = 'common'

  /**
   * 用户状态
   * @type {number}
   */
  @observable status = ACCOUNT_TYPE['normal'];

  /**
   * 登录成功
   * @type {string}
   */
  @observable token = '';

  /**
   * passport 返回id
   * @type {string}
   */
  @observable passportId = '';

  /**
   * 玩家绑定邮箱
   * @type {string}
   */
  @observable email = '';

  /**
   * 用户id
   * @type {string}
   */
  @observable openId = '';

  /**
   * 玩家呢称
   * @type {string}
   */
  @observable nickname = '';

  /**
   * 关联账号
   * @type {AssociatedAccountStore[]}
   */
  @observable associatedAccounts = [];

  @observable loading = false;

  @computed
  get name() {
    return this.email ? this.desensitizationEmail : this.nickname;
    /*switch (this.type) {
      case LOGIN_TYPE['mail']:
        return this.desensitizationEmail;
      default:
        return this.nickname;
    }*/
  }

  @computed
  get desensitizationEmail() {
    if (this.loading) {
      return this.email;
    }
    return desensitizationEmail(this.email);
  }

  /**
   * 状态登录
   * @return {boolean}
   */
  @computed
  get loginStatus() {
    return !!this.token;
  }

  originData = {};

  /**
   *
   * @param uid {string}
   * @param type {string}
   * @param status {number}
   * @param token {string}
   * @param passportId {string}
   * @param email {string}
   * @param ksOpenId {string}
   * @param nickname {string}
   * @param nickName {string}
   * @param associatedAccounts
   */
  updateStatus({
    uid = '',
    type = '',
    status = 0,
    token = '',
    passportId = '',
    email = '',
    ksOpenId = '',
    nickname = '',
    nickName = '',
    age = '',
    playerFillAge = false,
    associatedAccounts = []
  } = {}) {
    this.uid = uid;
    this.type = LOGIN_TYPE[type];
    this.status = status;
    this.token = token;
    this.passportId = passportId;
    this.email = email;
    this.openId = ksOpenId;
    this.nickname = nickname || nickName;
    this.age = age;
    this.playerFillAge = playerFillAge;
    this.associatedAccounts = !!this.email
      ? associatedAccounts.map(item => new AssociatedAccountStore(item))
      : associatedAccounts.filter(({ thirdPartyType }) => thirdPartyType === type).map(item => new AssociatedAccountStore(item));
    this.originData = arguments[0];
    this.updateStatusByLocalstorage(arguments[0] || '');
  }

  localstorageName = 'seasun-international-account';

  updateStatusByLocalstorage(data) {
    //const data = localStorage.getItem(this.name);
    // localStorage.setItem(this.name, JSON.stringify({}));
    // localStorage.setItem(this.localstorageName, JSON.stringify(data));
  }

  loadingBeforeHandle() {
    this.loading = true;
    this.email = intl.get('MODEL.ACCOUNT_STORE.LOADING.TEXT');
    this.nickname = intl.get('MODEL.ACCOUNT_STORE.LOADING.TEXT');
    this.passportId = intl.get('MODEL.ACCOUNT_STORE.LOADING.TEXT');
    this.uid = intl.get('MODEL.ACCOUNT_STORE.LOADING.TEXT');
  }
  loadingAfterHandle() {
    this.loading = false;
  }

  /**
   * 退出
   * @return {Promise<void>}
   */
  @autobind
  async logout() {
    try {
      await this.$service.logout({
        token: this.token
      });
      this.$service.logoutWithCookie().finally();
      this.updateStatus();
    } catch (e) {
      if (e.serviceResponse) {
        if (e.serviceResponse.code === 1004) {
          this.updateStatus();
        }
      }
    }
  }

  /**
   * 获取账号状态
   * @param token
   * @return {Promise<{ksOpenId: string, bindEmail: string}>}
   */
  checkAccount(token) {
    return this.$service.getAccountInfo({
      token
    });
  }

  /**
   * 从localstorage获取信息
   * @return {{}}
   */
  getDataByLocalstorage() {
    const data = localStorage.getItem(this.localstorageName);
    if (data && data !== 'undefined') {
      return JSON.parse(data);
    } else {
      return data;
    }
  }

  async refresh() {
    // const data = this.getDataByLocalstorage();
    const data = await this.checkAccount(this.token);
    this.updateStatus({ ...data });
  }

  /**
   * 获取用户信息
   * @return {Promise<void>}
   */
  async getAccountInfo() {
    if (this.loginStatus) {
      return;
    }
    //const data = this.getDataByLocalstorage();
    this.loadingBeforeHandle();
    try {
      const { ksOpenId, ...data } = await this.checkAccount('');
      this.updateStatus({ ...data, ksOpenId });
      /*if (data) {
        if (Object.keys(data).length) {
          const { ksOpenId } = await this.checkAccount(data.token);
          this.updateStatus({ ...data, ksOpenId });
        } else {
          this.updateStatus();
        }
      } else {
        this.updateStatus();
      }*/
    } catch (e) {
      // message.error(e.message);
      this.updateStatus();
    }
    this.loadingAfterHandle();
  }
}
const accountStore = new AccountStore();
// window.accountStore = accountStore;
export default accountStore;
